/* eslint-disable eqeqeq */
import config from '__api/config';
import { InvRewardDataVO } from '__api/dsbc/inv/getInvRewardList';
import Mask from '__components/Mask';
import { openUrl } from '__utils/openUrl';
import { Arrow } from 'emrn-design/Arrow';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, ScrollView } from 'react-native';

interface Props {
  onPress?: Function;
  data?: InvRewardDataVO[] | undefined;
}

interface State {
  isShow: boolean;
}

export class RewardRecordPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress, data } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.09 }}
                colors={['#C7DEFF', '#FFFFFF']}
                style={styles.main}
              >
                <EmTouchableOpacity
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    padding: 10,
                  }}
                  onPress={() => {
                    this.hide();
                  }}
                >
                  <Image
                    style={styles.closeImg}
                    source={require('../../images/invite/close.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>

                <Text style={styles.Tittext}>奖励记录</Text>
                <Spacer size={rpx(5)} />
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: '60%' }}>
                  <EmTouchableOpacity
                    style={styles.arrow_c}
                    onPress={() => {
                      onPress && onPress();
                    }}
                  >
                    <Text style={styles.text}>我的卡包</Text>
                    <Arrow color="#3A5DD7" size={6} direction="right" />
                  </EmTouchableOpacity>
                  <EmTouchableOpacity
                    style={styles.arrow_c}
                    onPress={() => {
                      openUrl(config.redPacketUrl);
                    }}
                  >
                    <Text style={styles.text}>我的钱包</Text>
                    <Arrow color="#3A5DD7" size={6} direction="right" />
                  </EmTouchableOpacity>
                </View>

                <View style={styles.tit}>
                  <Text style={styles.text_l}>时间</Text>
                  <Text style={styles.text_r}>奖品</Text>
                </View>
                {data && data.length > 0 ? (
                  <ScrollView style={styles.main_c}>
                    {data.map((item, index) => {
                      if (index % 2 == 0) {
                        return (
                          <View style={styles.item}>
                            <Text style={styles.text3} numberOfLines={1}>
                              {item.rwdDate}
                            </Text>
                            <Text style={styles.text3} numberOfLines={1}>
                              {item.reward}
                            </Text>
                          </View>
                        );
                      } else {
                        return (
                          <View style={styles.item1}>
                            <Text style={styles.text3} numberOfLines={1}>
                              {item.rwdDate}
                            </Text>
                            <Text style={styles.text3} numberOfLines={1}>
                              {item.reward}
                            </Text>
                          </View>
                        );
                      }
                    })}
                  </ScrollView>
                ) : null}
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    maxHeight: rpx(356),
    backgroundColor: '#fff',
    borderRadius: rpx(12),
    alignItems: 'center',
    paddingTop: rpx(24),
    paddingBottom: rpx(24),
    // position:'relative'
  },
  main_c: {
    maxHeight: rpx(222),
    width: '100%',
  },
  text: {
    fontSize: rpx(11),
    lineHeight: rpx(15),
    color: '#3A5DD7',
    fontWeight: 'bold',
    marginRight: rpx(2),
  },
  arrow_c: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  Tittext: {
    fontSize: rpx(20),
    color: '#3A5DD7',
    fontWeight: 'bold',
  },
  closeImg: {
    width: rpx(12),
    height: rpx(12),
  },
  text_l: {
    flex: 1,
    textAlign: 'center',
    fontSize: rpx(12),
    color: '#666666',
  },
  text_r: {
    flex: 1,
    textAlign: 'center',
    fontSize: rpx(12),
    color: '#666666',
  },
  text3: {
    flex: 1,
    textAlign: 'center',
    fontSize: rpx(12),
    color: '#333333',
  },
  tit: {
    width: '100%',
    display: 'flex',
    height: rpx(38),
    alignItems: 'center',
    flexDirection: 'row',
    // justifyContent:'space-between',
    paddingHorizontal: rpx(24),
  },
  item: {
    width: '100%',
    display: 'flex',
    height: rpx(32),
    // justifyContent:'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: 'rgba(106,146,255,0.1)',
    borderRadius: rpx(4),
    paddingHorizontal: rpx(24),
  },
  item1: {
    width: '100%',
    height: rpx(42),
    // justifyContent:'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderRadius: rpx(4),
    paddingHorizontal: rpx(24),
  },
});
